import { convertISODateTime, getNowISO } from "@utils/time-helpers";
import { reduceArrayOfObjToObj } from "@utils/array-helpers";

export const setSearchFilter = (
  status,
  search,
  startDate,
  stopDate,
  dateFormat,
  useMinMax
) => {
  // Only skip date params when redundant — always preserve status and search_all
  const skipDates = isDateInBounds(status, startDate, stopDate);

  let adjustedFilterStartDate =
    !skipDates && startDate
      ? convertISODateTime(startDate)[dateFormat]
      : null;
  let adjustedFilterStopDate =
    !skipDates && stopDate
      ? convertISODateTime(stopDate)[dateFormat]
      : null;

  let itemConfigs = {
    status,
    ...(adjustedFilterStopDate && {
      stop_date: adjustedFilterStopDate,
      ...(useMinMax && { max_stop_date: adjustedFilterStopDate }),
    }),
    ...(adjustedFilterStartDate && {
      start_date: adjustedFilterStartDate,
      ...(useMinMax && { min_start_date: adjustedFilterStartDate }),
    }),
    ...(search && { search_all: search }),
  };
  return itemConfigs;
};

const isDateInBounds = (status, startDate, stopDate) => {
  return status === "live"
    ? startDate
      ? convertISODateTime(startDate).toDate <= getNowISO()
      : false
    : stopDate
    ? convertISODateTime(stopDate).toDate > getNowISO()
    : false;
};

export const preSelection = (
  setSelected,
  key,
  set,
  enrichmentBeforeViewFunction = (value) => {}
) => {
  setSelected = reduceArrayOfObjToObj(setSelected, key);
  let updatedSet =
    enrichmentBeforeViewFunction && set
      ? set.map((item) => enrichmentBeforeViewFunction(item))
      : set;
  updatedSet = updatedSet
    ? updatedSet.map((item) =>
        setSelected[item[key]] && setSelected[item[key]].count !== undefined
          ? { ...item, count: setSelected[item[key]].count }
          : item
      )
    : [];
  return updatedSet;
};
